import React from "react";
import { useState, useEffect } from "react";
import getGame from "../../js/utils/async/getGame";

export default function useGame(credentials, link){

    const [isGameLoaded, setIsLoaded] = useState(false);
    const [isLogged, setIsLogged] = useState(false);
    const [game, setGame] = useState({});
  
    useEffect(() => {
      (async () => {
        if (credentials) {
          const result = await getGame(credentials, link);
          if (result.ok) {
            setIsLogged(true)
            setGame(result)
          } else setIsLogged(false)
          setIsLoaded(true)
        } else {
          setIsLoaded(true)
          setIsLogged(false)
        }
      })();

    })
  
    return {
      isLoaded: isGameLoaded,
      isLogged: isLogged,
      game: game

    }

}